// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".links[data-v-5bbe5f1a],form#login[data-v-5bbe5f1a]{margin-top:20px}.links[data-v-5bbe5f1a]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
